"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BarcodeResultsContent = void 0;
exports.BarcodeResultsContent = {
  en: {
    title: "Scan Result",
    subTitle: "Please select the matching product:",
    backButton: "Back",
    continueButton: "Continue",
    loading: "Loading Scanned results...",
    error: "There was an error. Please try again.",
    cpn: "CPN:",
    uom: "UOM:",
    quantityUOM: "Quantity (UOM):",
    priceUOM: "Price (UOM):",
    customerRef: "Customer Ref #:",
    alt: "ALT: ",
    headerPO: "Header Level PO:",
    linePO: "Line Level PO:",
    poReplacePrompt: "PO information was included in the scan and will overwrite any existing PO information. Do you want to continue?",
    poReplaceYes: "Yes, apply PO from scan",
    poReplaceNo: "No, don’t change PO"
  },
  es: {
    title: "Resultado de la exploracion",
    subTitle: "Seleccione el producto correspondiente:",
    backButton: "atrás",
    continueButton: "Continuer",
    loading: "Cargando resultados escaneados ...",
    error: "Hubo un problema. Por favor vuelva a intentar.",
    cpn: "CPN:",
    uom: "UOM:",
    quantityUOM: "Cantidad (UOM):",
    priceUOM: "Precio (UOM):",
    customerRef: "Ref. Cliente #:",
    alt: "ALT: ",
    headerPO: "Nivel de encabezado PO:",
    linePO: "Nivel de línea PO",
    poReplacePrompt: "Informacion de PO ha sido incluida en el scan y remplazarà qualquier PO predeterminado. Desea continuar?",
    poReplaceYes: "Si, aplicar el PO del scan",
    poReplaceNo: "No, no cambiar PO"
  },
  fr: {
    title: "Résultat de scanner",
    subTitle: "Veuillez sélectionner le produit correspondant:",
    backButton: "Arrière",
    continueButton: "Continuar",
    loading: "Chargement des résultats numérisés...",
    error: "Il y a eu un problème. Veuillez Réessayer.",
    cpn: "CPN:",
    uom: "UOM:",
    quantityUOM: "Quantité (UOM):",
    priceUOM: "Prix (UOM):",
    customerRef: "Réf client #:",
    alt: "ALT: ",
    headerPO: "Niveau d'en-tête PO:",
    linePO: "Niveau de ligne PO:",
    poReplacePrompt: "L’information du PO a été inclue dans le scan et remplacera tout PO par défaut. Souhaitez-vous continuer?",
    poReplaceYes: "Oui, appliquer le PO du scan",
    poReplaceNo: "Non, ne pas changer le PO"
  }
};